export const RECENTS_KEY = "command-palette-recents"
export const MAX_RECENTS = 12

export interface RecentEntry {
	id: string
	kind: "command" | "entity"
	label: string
	description?: string
	/** For entity recents: the identifier that re-resolves this entity when typed. */
	query?: string
	savedAt: number
}

export interface RecentsStore {
	getItem(key: string): string | null
	setItem(key: string, value: string): void
}

export function loadRecents(store: RecentsStore): RecentEntry[] {
	try {
		const raw = store.getItem(RECENTS_KEY)
		if (!raw) return []
		const parsed = JSON.parse(raw)
		if (!Array.isArray(parsed)) return []
		return parsed.filter(
			(entry): entry is RecentEntry =>
				typeof entry === "object" &&
				entry !== null &&
				typeof entry.id === "string" &&
				typeof entry.label === "string",
		)
	} catch {
		return []
	}
}

export function pushRecent(
	store: RecentsStore,
	entry: Omit<RecentEntry, "savedAt">,
	now = Date.now(),
): RecentEntry[] {
	const next = [
		{ ...entry, savedAt: now },
		...loadRecents(store).filter((existing) => existing.id !== entry.id),
	].slice(0, MAX_RECENTS)
	try {
		store.setItem(RECENTS_KEY, JSON.stringify(next))
	} catch {
		// storage unavailable; recents silently degrade
	}
	return next
}
